const stateName=(value:string)=>value
  .trim()
  .toLowerCase()
  .replaceAll(' ','_')
  .replaceAll('-','_');

const label=(value:string)=>value
  .replaceAll('_',' ')
  .replaceAll('-',' ');

export function Status({value}:{value:string}){
  const state=stateName(value);
  return <span className="tu-contract-status" data-state={state}>
    <span aria-hidden="true"/>
    {label(value)}
  </span>;
}
